import { useFetchSubscription } from "src/queries/hooks/accountSettings";
import { useFetchAdminSubscription } from "src/queries/hooks/admin";
import { TEAM_ROLES } from "./SubscriptionTab.consts";

const useSubscriptionTab = ({ accountId, isAccountContext, hasSalesforceId }) => {
  const accountQuery = useFetchSubscription({
    accountId,
    enabled: !!accountId && isAccountContext && hasSalesforceId
  });

  const adminQuery = useFetchAdminSubscription({
    accountId,
    enabled: !!accountId && !isAccountContext && hasSalesforceId
  });

  const { data, isLoading, isError } = isAccountContext ? accountQuery : adminQuery;

  const opportunities = data?.opportunities || [];

  const teamMembers = [];
  if (data?.ownerName) {
    teamMembers.push({ name: data.ownerName, role: TEAM_ROLES.ownerName });
  }
  if (data?.solutionArchitect) {
    teamMembers.push({ name: data.solutionArchitect, role: TEAM_ROLES.solutionArchitect });
  }

  return {
    opportunities,
    teamMembers,
    interactionLimit: data?.interactionLimit,
    interactionDefinition: data?.interactionDefinition,
    isLoading,
    isError,
    isEmpty: !isLoading && !isError && opportunities.length === 0
  };
};

export default useSubscriptionTab;
